<script>

export default {
  name: 'Login',

  data() {

    return {
      host: '',
      apiToken: ''
    }

  },

  methods: {
    submit() {
      this.$emit('submit', this.host, this.apiToken)
    }
  }
}

</script>

<template>
  <div class="login">
    <h2>Login</h2>
    <label for="host">Graylog-Host</label>
    <input id="host" type="text" v-model="host">

    <label for="api-token">Api Token</label>
    <input id="api-token" type="text" v-model="apiToken">

    <button @click="submit">Login</button>
  </div>
</template>

<style scoped>
div.login {
  max-width: 30rem;
  margin: auto;
  margin-top: 40px;
}
input {
  border-radius: 4px;
}
h2 {
  font-size: 2.5rem;
  margin-bottom: 30px;
}
button {
  color: #333;
  padding: 10px;
  border-radius: 4px;
  background-color: #45b382;
}
</style>
